// listeners/conversationListener.js
import { supabase } from "./supabaseClient";
import {
  updateConversation,
  recalculateTotalUnread,
} from "../redux/Slices/chatSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

export const ConversationListener = () => {
  const myHccId = localStorage.getItem("hcc_id");
  const dispatch = useDispatch();
  const activeChatUserId = useSelector((state) => state.chat.activeChatUserId);

  useEffect(() => {
    if (!myHccId) return;

    const fetchInitialConversations = async () => {
      const { data, error } = await supabase
        .from("conversations")
        .select("*")
        .or(`user1_id.eq.${myHccId},user2_id.eq.${myHccId}`);

      if (error) {
        console.error("[Fetch] Error loading conversations:", error.message);
        return;
      }

      console.log("[Fetch] Initial conversations loaded:", data);
      data.forEach((convo) => dispatch(updateConversation(convo)));
    };

    fetchInitialConversations(); // 👈 This line does the fetch and Redux push

    const channel = supabase
      .channel("conversation-updates")
      .on(
        "postgres_changes",
        {
          event: "UPDATE",
          schema: "public",
          table: "conversations",
        },
        (payload) => {
          const updatedConvo = payload.new;
          console.log("[Realtime][UPDATE] Conversation updated:", updatedConvo);

          const isMyConvo =
            updatedConvo.user1_id === myHccId ||
            updatedConvo.user2_id === myHccId;

          const otherUser =
            updatedConvo.user1_id === myHccId
              ? updatedConvo.user2_id
              : updatedConvo.user1_id;

          if (isMyConvo) {
            dispatch(updateConversation(updatedConvo));

            if (activeChatUserId !== otherUser) {
              dispatch(recalculateTotalUnread());
            }
          }
        }
      )
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "conversations",
        },
        (payload) => {
          const newConvo = payload.new;
          console.log("[Realtime][INSERT] New conversation:", newConvo);

          const isMyConvo =
            newConvo.user1_id === myHccId || newConvo.user2_id === myHccId;

          if (isMyConvo) {
            dispatch(updateConversation(newConvo));
            dispatch(recalculateTotalUnread());
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [dispatch, activeChatUserId]);

  return null; // This is a hook-style component
};
